import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Type } from "lucide-react";

export const FontSizeToggle = () => {
  const [isLargeFont, setIsLargeFont] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("large-font");
    if (saved === "true") {
      setIsLargeFont(true);
      document.documentElement.classList.add("large-font");
    }
  }, []);

  const toggleFontSize = () => {
    setIsLargeFont((prev) => {
      const next = !prev;
      if (next) {
        document.documentElement.classList.add("large-font");
        localStorage.setItem("large-font", "true");
      } else {
        document.documentElement.classList.remove("large-font");
        localStorage.setItem("large-font", "false");
      }
      return next;
    });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleFontSize}
      aria-label={isLargeFont ? "Decrease font size" : "Increase font size"}
      className={`rounded-full h-9 w-9 p-0 flex items-center justify-center ${isLargeFont ? "bg-primary text-primary-foreground hover:bg-primary/90" : "text-muted-foreground hover:text-primary"}`}
    >
      <Type className="h-4 w-4" />
      <span className="sr-only">Text Size</span>
    </Button>
  );
};
